<template>
  <div class="page">
    <b-card>
      <div class="d-flex justify-content-between gap-2 mb-3">
        <h1>Create Admin</h1>
      </div>

      <b-form @submit="createAdmin">
        <b-form-group
          id="name"
          label="Name:"
          label-for="name"
          label-cols-md="3"
          label-align-sm="right"
          :state="errors.name ? false : null"
          :invalid-feedback="errors.name"
        >
          <b-form-input
            id="name"
            v-model="name"
            type="text"
            placeholder="Enter name"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="email"
          label="Email:"
          label-for="email"
          label-cols-md="3"
          label-align-sm="right"
          :state="errors.email ? false : null"
          :invalid-feedback="errors.email"
        >
          <b-form-input
            id="email"
            v-model="email"
            type="email"
            placeholder="Enter email"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="password"
          label="Password:"
          label-for="password"
          label-cols-md="3"
          label-align-sm="right"
          :state="errors.password ? false : null"
          :invalid-feedback="errors.password"
        >
          <b-form-input
            id="password"
            v-model="password"
            type="password"
            placeholder="Enter password"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="role"
          label="Role:"
          label-for="role"
          label-cols-md="3"
          label-align-sm="right"
          :state="errors.role ? false : null"
          :invalid-feedback="errors.role"
        >
          <b-form-select
            id="role"
            v-model="role"
            :options="roles"
          ></b-form-select>
        </b-form-group>

        <b-button type="submit" variant="primary">Create Admin</b-button>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import AdminService from "@/core/services/admin.service";
import { yupToKV } from "../../../core/utils/yupToKV";
import { object, string } from "yup";
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      role: "Admin",
      roles: [
        { value: "Admin", text: "Admin" },
        { value: "SuperAdmin", text: "Super Admin" },
      ],
      errors: {},
    };
  },
  computed: {
    validationSchema() {
      return object().shape({
        name: string()
          .trim()
          .min(2, "Your name must be at least 2 characters long.")
          .max(100, "Your name must be no longer than 100 characters.")
          .required("Name is required"),
        email: string()
          .trim()
          .email("Invalid email")
          .required("Email is required"),
        password: string()
          .min(6, "Your password must be at least 6 characters long.")
          .max(100, "Your password must be no longer than 100 characters.")
          .matches(
            /[A-Z]/,
            "Your password must contain at least one uppercase letter."
          )
          .matches(
            /[a-z]/,
            "Your password must contain at least one lowercase letter."
          )
          .matches(/[0-9]/, "Your password must contain at least one number.")
          .matches(
            /[\^$*.[\]{}()?"!@#%&/,><':;|_~`]/,
            "Your password must contain at least one special character."
          )
          .required("Password is required"),
        role: string().trim().required("Role is required"),
      });
    },
  },
  methods: {
    async createAdmin(e) {
      e.preventDefault();
      this.errors = {};
      try {
        const admin = {
          name: this.name,
          email: this.email,
          password: this.password,
          role: this.role,
        };
        await this.validationSchema
          .validate(admin, { abortEarly: false })
          .catch((err) => {
            this.errors = yupToKV(err);
          });

        if (this.validationSchema.isValidSync(admin)) {
          await AdminService.createAdmin(admin);
          this.$toast("Admin created successfully");
          this.$router.push({ name: "all-admins" });
        }
      } catch (error) {
        this.errors = error.response.data.error;
        this.$toast(error.response.data.message, { type: "error" });
      } finally {
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Admins", route: "/admins" },
      { title: "Create Admin", route: "/admins/create" },
    ]);
  },
};
</script>
